import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardsInfoFiltersService } from '@docpath/linces-angular-components';
import { DPCardsInfoFiltersModule, DpChartModule, DpFilterCardModule, DpFormModule, DpHeaderModule, DpModalFormService, DpModalService, DpPaginationModule, DpSearchModule, DpTableModule } from '@docpath/webcomponents';
import { TranslateModule } from '@ngx-translate/core';

import { HomeChartComponent } from './components/chart/home-chart.component';
import { HomeHeaderComponent } from './components/header/home-header.component';
import { HomeTableComponent } from './components/table/home-table.component';
import { HomeComponent } from './home.component';

@NgModule({
  declarations: [
    HomeChartComponent,
    HomeComponent,
    HomeTableComponent,
    HomeHeaderComponent
  ],
  imports: [
    CommonModule,
    DpFormModule,
    DpHeaderModule,
    DpPaginationModule,
    DpSearchModule,
    DpTableModule,
    TranslateModule,
    DpChartModule,
    DpFilterCardModule,
    DPCardsInfoFiltersModule
  ],
  providers: [
    DpModalService,
    DpModalFormService,
    CardsInfoFiltersService
  ]
})
export class HomeModule { }
